const foldersRoles = ["agent", "folders", "manager", "pm_feature_listings"];

const noSavedSearches = [
  "rental_portfolio_manager",
  "marketing_professional",
  "small_landlord"
];

const getSavedSearchesUrl = userRole => {
  if (!userRole) return "/my/saved_searches";

  const userRoleList = userRole.split(",");

  if (noSavedSearches.some(role => userRoleList.includes(role))) return null;

  if (foldersRoles.some(role => userRoleList.includes(role))) return "/folders";

  return "/my/saved_searches";
};

export default getSavedSearchesUrl;
